export const systemHealthApi = (client) => ({
    getLive: () => client.get('/api/v1/super-admin/system-health/live').then((r) => r.data),
    /** One snapshot per minute — `hours` caps at 720 (30 days), matching the server's retention window. */
    getHistory: (hours = 24) => client.get('/api/v1/super-admin/system-health/history', { params: { hours } }).then((r) => r.data),
});
//# sourceMappingURL=system-health.js.map